import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { Coords, TrackingMethodCoords } from '../../models/main';
import { ApiService } from '../../services/api.service';


@Component({
  selector: 'app-map-visor-modal',
  templateUrl: './map-visor-modal.component.html',
  styleUrls: ['./map-visor-modal.component.scss'],
})

export class MapVisorModalComponent implements OnInit, OnDestroy {
  id!: string;
  recordId!: string;
  resourceId!: string;
  center!: google.maps.LatLngLiteral;

  marker = {
    position: { lat: 0, lng: 0 },
    label: '🚛',
  };

  sub?: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: string, recordId: string, resourceId: string, lastLocation: Coords, label: string },
    private api: ApiService,
  ) {
    this.id = data.id;
    this.recordId = data.recordId;
    this.resourceId = data.resourceId;
    this.center = data.lastLocation;
    this.marker = {
      position: data.lastLocation,
      label: '🚛',
    };
  }

  ngOnInit() {
    this.sub = timer(0, 10000)
      .pipe(switchMap(() => this.api.getTrackingMethod<TrackingMethodCoords>(this.recordId, this.resourceId, this.id)))
      .subscribe({
        next: (pos) => {
          this.updateMarker(pos);
        },
        error: () => this.api.logError('errorsHttp.Internal'),
      });
  }

  updateMarker(pos: TrackingMethodCoords) {
    this.marker = {
      position: { lat: pos.data.lastLocation.lat, lng: pos.data.lastLocation.lng },
      label: '🚛',
    };
    this.center = this.marker.position;
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

}
